module.exports = __webpack_public_path__ + "static/img/jbalert.d08da8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/jbalert.png
// module id = 1224
// module chunks = 0